import React from 'react';
export default function Associations({ list }) {
  return (
    <section className='max-w-6xl mx-auto px-4 py-12'>
      <h2 className='text-2xl font-bold mb-6'>Asociaciones y Aliados</h2>
      <div className='flex gap-6 items-center flex-wrap'>
        {list.map(a => (
          <div key={a.id} className='bg-white border rounded px-4 py-3 shadow-sm'>{a.name}</div>
        ))}
      </div>
    </section>
  );
}
